import { forwardRef } from 'react'

import styles from './styles.module.scss'

const YOUTUBE_LINK = 'https://www.youtube.com/embed/HmVKWfYx6kk'

export const VideoSection = forwardRef<HTMLElement>((_, ref) => {
  return (
    <section className={styles['section-container']} ref={ref}>
      <div className={styles['content']}>
        <iframe
          className={styles['iframe']}
          src={YOUTUBE_LINK}
          title="Life is made of opportunities"
          allow="accelerometer; clipboard-write; encrypted-media; gyroscope; picture-in-picture"
        ></iframe>
      </div>
    </section>
  )
})

export default VideoSection
